import { useLanguageData } from '@/common/hooks/useLanguageData';
import { GhostAction } from '@/common/styles/shared.styles';
import { LoadMoreWrap } from '../homePersonGrid.styles';

const HomePersonGridLoadMore = ({ hasMore, isLoadingMore, onLoadMore }) => {
	const common = useLanguageData('common');

	if (!hasMore) {
		return null;
	}

	return (
		<LoadMoreWrap>
			<GhostAction type="button" onClick={onLoadMore} disabled={isLoadingMore}>
				{isLoadingMore ? common.loading : common.loadMore}
			</GhostAction>
		</LoadMoreWrap>
	);
};

export default HomePersonGridLoadMore;
